import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import * as Sentry from '@sentry/react';

import { hasAdminAccess } from '../../../lib/services/user.service';
import { APP_TITLE, HOME_ROUTE } from '../../../../_configuration';
import ErrorPage from '../../_pages/_boilerplate/ErrorPage/error-page.container';
import LoadingPage from '../../_pages/_boilerplate/LoadingPage/loading-page.container';

interface IAdminRouteProps {
  component: any;
  title?: string;
  exact?: boolean;
  path: string;
}

// Route-level gate for global-Max-admin-only pages. `isAdmin` is a User-level
// flag, not a company ROUTE_ROLE, so it can't go through RouteByRole's role
// machinery. Honor `loading` so an admin isn't flash-redirected while
// getCurrUser's cache-and-network fetch resolves.
export const AdminRoute: React.FC<IAdminRouteProps> = ({ component: Component, title, ...rest }) => {
  const { isAdmin, loading } = hasAdminAccess();

  if (loading) return <Route render={() => <LoadingPage />} />;
  if (!isAdmin) return <Route render={() => <Redirect to={HOME_ROUTE} />} />;

  document.title = title || APP_TITLE;

  return (
    <Route
      {...rest}
      render={props => (
        <Sentry.ErrorBoundary fallback={ErrorPage}>
          <Component {...props} />
        </Sentry.ErrorBoundary>
      )}
    />
  );
};
